var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightPcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M8.713,0.91c-1.888,0.129-1.7,2.323-1.7,2.323c0.419,2.441,3.982,4.957,5.599,6.989c0,0,1.01-0.033,1.123-2.042 C13.755,5.803,9.132,3.35,8.713,0.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M11.25,13.18c-0.008-0.016-0.024-0.032-0.032-0.048c0-0.008-0.008-0.008-0.016-0.016"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M9.074,10.725C8.7,10.35,8.333,9.968,7.998,9.593C7.99,9.585,7.99,9.585,7.99,9.577C7.36,8.86,6.874,8.142,6.747,7.425 c0,0-0.241-1.859,1.02-2.192c0.032-0.016,0.064-0.032,0.096-0.048"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M12.685,10.295c0.526,0.67,0.885,1.339,0.877,1.993c-0.064,1.18-0.67,1.802-1.156,2.104c0,0.008-0.008,0.008-0.008,0.008"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M9.074,10.725c0.69,0.763,1.323,1.578,2.096,2.359c0.008,0.008,0.016,0.008,0.016,0.016c0.423,0.422,0.829,0.837,1.188,1.259 c0.678,0.789,1.164,1.57,1.156,2.344c-0.12,2.009-1.794,2.407-1.794,2.407c0.024-2.375-4.599-4.831-5.022-7.27 c0,0-0.08-1.81,1.244-2.296c0,0.008,0,0.008,0.008,0.016"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightPcp);
export default __webpack_public_path__ + "static/media/light-pcp.2283c4e9542f44389ea0476323bed293.svg";
export { ForwardRef as ReactComponent };